import { useEffect } from "react";

/**
 * Global screenshot & content protection.
 * Blocks: right-click, PrintScreen, Cmd+Shift+3/4 (Mac), Ctrl+P, drag-select.
 * Adds a transparent overlay on blur to prevent screenshot tools from capturing.
 */
export default function ScreenShield() {
  useEffect(() => {
    // Block right-click context menu
    const blockContext = (e) => { e.preventDefault(); };
    document.addEventListener("contextmenu", blockContext);

    // Block keyboard shortcuts for screenshots & printing
    const blockKeys = (e) => {
      // PrintScreen
      if (e.key === "PrintScreen") { e.preventDefault(); navigator.clipboard.writeText(""); }
      // Cmd+Shift+3/4/5 (Mac screenshots)
      if (e.metaKey && e.shiftKey && ["3", "4", "5"].includes(e.key)) { e.preventDefault(); }
      // Ctrl+Shift+S (Windows Snipping)
      if (e.ctrlKey && e.shiftKey && e.key.toLowerCase() === "s") { e.preventDefault(); }
      // Ctrl+P / Cmd+P (Print)
      if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === "p") { e.preventDefault(); }
      // Ctrl+S / Cmd+S (Save)
      if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === "s") { e.preventDefault(); }
      // Ctrl+U (View source)
      if (e.ctrlKey && e.key.toLowerCase() === "u") { e.preventDefault(); }
      // F12 (DevTools)
      if (e.key === "F12") { e.preventDefault(); }
      // Ctrl+Shift+I (DevTools)
      if (e.ctrlKey && e.shiftKey && e.key.toLowerCase() === "i") { e.preventDefault(); }
    };
    document.addEventListener("keydown", blockKeys);

    // Block drag (prevents saving images by dragging)
    const blockDrag = (e) => { e.preventDefault(); };
    document.addEventListener("dragstart", blockDrag);

    // WhatsApp-style: blank screen when app loses focus (screenshot tools)
    let overlay = null;
    const handleBlur = () => {
      overlay = document.createElement("div");
      overlay.id = "screen-shield-overlay";
      overlay.style.cssText = "position:fixed;inset:0;z-index:99999;background:#030014;display:flex;align-items:center;justify-content:center;";
      const inner = document.createElement("div");
      inner.style.textAlign = "center";
      const title = document.createElement("div");
      title.style.cssText = "font-size:24px;font-weight:800;background:linear-gradient(135deg,#fff,#c084fc,#f97316);-webkit-background-clip:text;-webkit-text-fill-color:transparent;";
      title.textContent = "PRÓXIMA LABS";
      const subtitle = document.createElement("p");
      subtitle.style.cssText = "color:#64748b;font-size:13px;margin-top:8px;";
      subtitle.textContent = "Contenido protegido";
      inner.appendChild(title);
      inner.appendChild(subtitle);
      overlay.appendChild(inner);
      document.body.appendChild(overlay);
    };
    const handleFocus = () => {
      const el = document.getElementById("screen-shield-overlay");
      if (el) el.remove();
      overlay = null;
    };
    window.addEventListener("blur", handleBlur);
    window.addEventListener("focus", handleFocus);

    return () => {
      document.removeEventListener("contextmenu", blockContext);
      document.removeEventListener("keydown", blockKeys);
      document.removeEventListener("dragstart", blockDrag);
      window.removeEventListener("blur", handleBlur);
      window.removeEventListener("focus", handleFocus);
      if (overlay) overlay.remove();
    };
  }, []);

  return null;
}
